import { useId } from 'react';

import { Input } from '~/components/shadcn/input.tsx';
import { Label } from '~/components/shadcn/label.tsx';
import { cn } from '~/utils/cn.ts';

import ErrorList, { type ErrorClassNames, type ListOfErrors } from './ErrorList.tsx';

export default function Field({
	additionalContext,
	classNames,
	errors,
	inputProps,
	labelProps,
}: {
	additionalContext?: React.ReactNode;
	classNames?: {
		container?: string;
		label?: string;
		input?: string;
		error?: ErrorClassNames;
	};
	errors?: ListOfErrors;
	inputProps: React.InputHTMLAttributes<HTMLInputElement>;
	labelProps?: React.LabelHTMLAttributes<HTMLLabelElement>;
}) {
	const fallbackId = useId();
	const id = inputProps.id ?? fallbackId;
	const errorId = errors?.length ? `${id}-error` : undefined;
	return (
		<div className={classNames?.container}>
			{labelProps?.children && (
				<Label
					className={cn('text-xs', errorId ? 'text-negative' : '', classNames?.label)}
					htmlFor={id}
					{...labelProps}
				/>
			)}
			<Input
				aria-describedby={errorId}
				aria-invalid={errorId ? true : undefined}
				className={cn(errorId ? 'border-negative' : '', classNames?.input)}
				id={id}
				{...inputProps}
			/>
			{additionalContext ?? null}
			<ErrorList classNames={classNames?.error} errors={errors} id={errorId} />
		</div>
	);
}
